import { Icon } from "@/components/icons";

type BatchStatusIconProps = {
  processing?: boolean;
  parsingErrorMessages?: string[];
};

export function BatchStatusIcon({ processing, parsingErrorMessages }: BatchStatusIconProps) {
  if (parsingErrorMessages?.length) {
    return (
      <span className="flex size-5 shrink-0 items-center justify-center text-red-600">
        <Icon name="error" size={20} label="Parsing errors" />
      </span>
    );
  }
  if (processing) {
    return (
      <span
        role="status"
        aria-label="Processing"
        title="Processing"
        className="flex size-5 shrink-0 items-center justify-center"
      >
        <span className="size-3.5 animate-spin rounded-full border-2 border-green-200 border-t-green-500" />
      </span>
    );
  }
  return (
    <span
      title="Processed"
      className="flex size-5 shrink-0 items-center justify-center text-green-600"
    >
      <Icon name="check_circle" size={20} filled label="Processed" />
    </span>
  );
}
